// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import Footer from "./components/Footer";
import AboutUsPage from "./pages/AboutUsPage";
import UseCasesPage from "./pages/UseCasesPage";
import ContactUs from "./pages/ContactUs";
import SolutionPage from "./pages/SolutionPage";
import RequestDemo from "./pages/RequestDemo";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";

// Import the ScrollToTop component
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    // <BrowserRouter>
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/use-cases" element={<UseCasesPage />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/solutions" element={<SolutionPage />} />
          <Route path="/request-demo" element={<RequestDemo />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsAndConditionsPage />} />

          {/* Other routes would go here if you add more pages */}
        </Routes>
      </main>
      <Footer />
    </div>
    // </BrowserRouter> // Close BrowserRouter if you added it here
  );
}

export default App;
